// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__gV_DT","header":"PatientBlock_header__25Y2a","label":"PatientBlock_label__302FY","option":"PatientBlock_option__3dB8x"};